import React from "react"
import Container from "../core/Container"
import Button from "../core/Button"
import Heading from "../core/Heading"
import Image from "../core/Image"

export default function InfoPopUp({ title, text, onClick, type = "success" }) {
    const isSuccess = type === "success"
    
    // Ikony pro různé typy zpráv
    const iconConfig = {
        success: {
            icon: "/img/digiboy_thumb_up.png",
            bgColor: "bg-green-50",
            borderColor: "border-green-200",
            textColor: "text-green-800"
        },
        error: {
            icon: "/img/digiboy_bulb.png",
            bgColor: "bg-red-50",
            borderColor: "border-red-200",
            textColor: "text-red-800"
        }
    }

    const config = iconConfig[type] || iconConfig.success

    return (
        <Container 
            bgColor="transparent" 
            className="fixed inset-0 z-50 flex items-center justify-center p-4 animate-fadeIn"
            onClick={(e) => {
                // Zavřít při kliknutí na backdrop
                if (e.target === e.currentTarget) {
                    onClick()
                }
            }}
        >
            {/* Backdrop */}
            <Container className="absolute inset-0 bg-black bg-opacity-50 backdrop-blur-sm" />
            
            {/* Popup Content */}
            <Container 
                bgColor="white" 
                radius="xl" 
                shadow 
                className={`relative z-10 max-w-md w-full p-6 sm:p-8 border-2 ${config.borderColor} transform transition-all duration-300 animate-scaleIn`}
            >
                {/* Close Button */}
                <button
                    onClick={onClick}
                    className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors p-1 rounded-full hover:bg-gray-100"
                    aria-label="Zavřít"
                >
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>

                {/* Icon */}
                <Container className="flex justify-center mb-4">
                    <Container className="rounded-full p-4 w-64 h-auto flex items-center justify-center">
                        <Image 
                            src={config.icon} 
                            alt={isSuccess ? "Úspěch" : "Chyba"} 
                            className="w-64 h-auto object-contain"
                        />
                    </Container>
                </Container>

                {/* Title */}
                <Container className="text-center mb-4">
                    <Heading variant="h2" className={`text-2xl font-bold ${config.textColor}`}>
                        {title}
                    </Heading>
                </Container>

                {/* Text */}
                <Container className="text-center mb-6">
                    <p className="text-gray-700 leading-relaxed text-base">
                        {text}
                    </p>
                </Container>

                {/* Action Button */}
                <Container className="flex justify-center">
                    <Button 
                        variant={isSuccess ? "primary" : "secondary"} 
                        size="lg"
                        onClick={onClick}
                        className="min-w-[120px]"
                    >
                        Zavřít
                    </Button>
                </Container>
            </Container>
        </Container>
    )
}